import classNames from 'classnames';
import useLayout from 'hooks/use-layout';
import type { ReactNode } from 'react';
import type { Layout } from 'types/layout';
import { validateString } from 'utils/validate-string';

import styles from './two-column.module.scss';

interface Props {
  image?: ReactNode | undefined;
  layout: Layout;
}

interface State {
  rootClass: string;
  contentClassName: string;
}

const centerClass = validateString(styles.center);
const contentWrapperClass = validateString(styles.contentWrapper);

export default function useTwoColumn({ layout, image }: Props): State {
  const layoutClass = useLayout({
    layout,
    styles,
  });

  return {
    rootClass: classNames(
      typeof image === 'undefined' ? centerClass : layoutClass,
    ),
    contentClassName: classNames(contentWrapperClass, layoutClass),
  };
}
